import React, { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import i18next from 'i18next';
import '../styles/library.css';
import PdfViewerModal from './PdfViewerModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const db = firebase.firestore();

const CampaignLibrary = ({ campaignUid, user, isDm }) => {
  const [docs, setDocs] = useState([]);
  const [viewerPdf, setViewerPdf] = useState(null);

  useEffect(() => {
    if (!campaignUid) return;
    const unsub = db.collection('campaignLibrary').doc(campaignUid)
      .collection('docs')
      .onSnapshot(
        snap => setDocs(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
        err => console.error('CampaignLibrary error:', err)
      );
    return () => unsub();
  }, [campaignUid]);

  const removeDoc = async (doc) => {
    await db.collection('campaignLibrary').doc(campaignUid).collection('docs').doc(doc.id).delete();
    await db.collection('library').doc(doc.pdfId || doc.id).update({
      campaignIds: firebase.firestore.FieldValue.arrayRemove(campaignUid),
    });
  };

  if (docs.length === 0) {
    return (
      <div className="mapEmpty">
        <span>{i18next.t('library.campaignEmpty')}</span>
      </div>
    );
  }

  return (
    <div className="campaignLibraryContainer">
      <div className="libraryGrid">
        {docs.map(doc => (
          <div key={doc.id} className="libraryCard">
            <div className="libraryCardHeader">
              <span className={`libraryCardType libraryCardType--${doc.type}`}>
                {i18next.t(`library.types.${doc.type}`)}
              </span>
            </div>
            <h3 className="libraryCardTitle">{doc.title}</h3>
            <p className="libraryCardAuthor">{doc.authorName}</p>
            <div className="libraryCardActions">
              <button className="libraryCardBtn" onClick={() => setViewerPdf(doc)}>
                {i18next.t('library.read')}
              </button>
              {isDm && (
                <button
                  className="libraryDeleteBtn"
                  onClick={() => removeDoc(doc)}
                  title={i18next.t('library.removeFromCampaign')}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      {viewerPdf && (
        <PdfViewerModal
          pdf={viewerPdf}
          user={user}
          onClose={() => setViewerPdf(null)}
        />
      )}
    </div>
  );
};

export default CampaignLibrary;
